import { Link } from '@tanstack/react-router';
import type { ReactNode } from 'react';
import { SECTIONS } from '../../lib/sections';
import { Wordmark } from '../../ui/Wordmark';
import styles from './Auth.module.css';

/** The public site, where the terms and the privacy policy live. */
const SITE_URL = 'https://dovefiniscono.com';

export function AuthLayout({
  title,
  subtitle,
  children,
}: {
  title: string;
  subtitle?: string;
  children: ReactNode;
}) {
  return (
    <div className={styles.layout}>
      <main className={styles.formSide}>
        <Link to="/" className={styles.brand} aria-label="dovefiniscono">
          <Wordmark />
        </Link>
        <div className={styles.form}>
          <h1 className={styles.title}>{title}</h1>
          {subtitle ? <p className={styles.subtitle}>{subtitle}</p> : null}
          <div className={styles.body}>{children}</div>
          <p className={styles.legal}>
            Continuando accetti i <a href={`${SITE_URL}/termini`}>termini di servizio</a> e l’
            <a href={`${SITE_URL}/privacy`}>informativa sulla privacy</a>.
          </p>
        </div>
      </main>
      <aside className={styles.statement} aria-hidden="true">
        <p className={styles.line}>
          Dove finiscono
          <br />i tuoi soldi
          <br />e il tuo tempo<span className={styles.dot}>.</span>
        </p>
        <ol className={styles.areas}>
          {SECTIONS.map((section) => (
            <li key={section.to} data-tone={section.tone}>
              <span className={styles.index}>0{section.key}</span>
              {section.label}
            </li>
          ))}
        </ol>
      </aside>
    </div>
  );
}
